// src/pages/marketing/MetaCallbackBridge.jsx
import { useEffect } from 'react';

export default function MetaCallbackBridge() {
  useEffect(() => {
    // Pega o code da URL atual (sem hash)
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    
    if (code) {
      // Redireciona para a rota com hash, mantendo o code
      window.location.replace(`/#/meta/callback?code=${code}`);
    } else {
      // Se não tem code, redireciona para a tela de conexão
      window.location.replace('/#/marketing/conectar?erro=missing_code');
    }
  }, []);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Redirecionando...</span>
      </div>
      <p className="mt-3">Redirecionando...</p>
    </div>
  );
}